/**
 * @deprecated
 * Includes are deprecated. See IMP-1330
 */
export enum INTERVENTIONS_INCLUDES {
  PROJECT = "project",
  TEMPLATE = "template",
  USERS = "users",
}

export enum INTERVENTIONS_SORTS {
  SCHEDULED_DATE_DESC = "-scheduled_date",
}

export enum INTERVENTIONS_FILTERS {
  CONTEXT = "context[organization]",
  ASSET_ID = "filter[asset_id]",
  ASSET_LOCATION_ID = "filter[asset.location_id]",
  RECOMMENDATION_ID = "filter[recommendation_id]",
  PROJECT_ID = "filter[project_id]",
  RECOMMENDED_FOR = "filter[recommended_for]",
  USERS_ID = "filter[users.id]",
  INTERVENTION_TYPE_ID = "filter[intervention_type_id]",
}
